import { Box, styled } from "@mui/material"

export const FullWidthContent = styled(Box)({
  gridColumn: "1 / 5", // Merge grid areas to cover them all (full width)
  gridRow: "1 / 4", // Merge row to cover them all ( full height)
})
